import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { ChatThread } from 'src/app/models/chat';

/** The left of the chat page: start a new chat, or go back to an earlier one. */
@Component({
    selector: 'app-chat-sidebar',
    templateUrl: './chat-sidebar.component.html',
    styleUrls: ['./chat-sidebar.component.scss'],
})
export class ChatSidebarComponent {
    @Input() threads: ChatThread[] = [];
    /** The id of the conversation on screen */
    @Input() activeThread: string | null = null;
    @Input() hasMore: boolean = false;
    @Input() loading: boolean = false;
    /** The chats could not be fetched */
    @Input() failed: boolean = false;

    /** A link to a conversation, or to a new one, was followed */
    @Output() navigated = new EventEmitter<void>();
    @Output() rename = new EventEmitter<{ thread: ChatThread, title: string }>();
    @Output() remove = new EventEmitter<ChatThread>();
    @Output() loadMore = new EventEmitter<void>();
    @Output() retry = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();

    /** The id of the conversation whose title is being edited */
    editing: string | null = null;

    @ViewChildren('titleInput') private titleInputs: QueryList<ElementRef<HTMLInputElement>>;

    trackByThread(_index: number, thread: ChatThread): string {
        return thread.thread_id;
    }

    startRename(thread: ChatThread): void {
        this.editing = thread.thread_id;
        // Once the menu has closed and given the focus back, and the box is there to take it
        setTimeout(() => {
            const box = this.titleInputs.first?.nativeElement;
            box?.focus();
            box?.select();
        });
    }

    /** Also reached when the box loses the focus, which it does as it is taken away. */
    saveTitle(thread: ChatThread, title: string): void {
        if (this.editing !== thread.thread_id) {
            return;
        }
        this.editing = null;
        const renamed = title.trim();
        if (renamed && renamed !== thread.title) {
            this.rename.emit({ thread, title: renamed });
        }
    }

    cancelRename(): void {
        this.editing = null;
    }
}
